import React from 'react';
import CategoriesManagement from './CategoriesManagement';

const Categories = () => {
  return <CategoriesManagement />;
};

export default Categories;
